module.exports = __webpack_public_path__ + "img/logo.0c1d3b56.png";